<!-- eslint-disable no-irregular-whitespace -->
<template>
  <!-- 詳細結果 -->
  <q-dialog v-model="detailResultFlgComputed" class="itemdetail-dialog" persistent>
    <q-card>
      <q-card-section class="row items-center q-pb-none result-dialog-header">
        <h3 class="text-h6" style="width: 130px">詳細結果</h3>
        <div class="pagination" :style="!showResultPagerFlg ? 'display:none' : ''">
          <div class="flex items-center pagination-content">
            <q-btn
              icon="mdi-less-than"
              :class="
                'pager-icon ' +
                (attoIdListComputed.indexOf(selectAttoIdComputed) === 0 ? 'disabled' : '')
              "
              :disabled="attoIdListComputed.indexOf(selectAttoIdComputed) === 0"
              @click="previousItem(attoIdListComputed.indexOf(selectAttoIdComputed) - 1)"
            />
            <p>
              <span>{{ attoIdListComputed.indexOf(selectAttoIdComputed) + 1 }}</span>
              / {{ attoIdListComputed.length }} 件目
            </p>
            <q-btn
              icon="mdi-greater-than"
              :class="
                'pager-icon ' +
                (attoIdListComputed.indexOf(selectAttoIdComputed) + 1 === attoIdListComputed.length
                  ? 'disabled'
                  : '')
              "
              :disabled="
                attoIdListComputed.indexOf(selectAttoIdComputed) + 1 === attoIdListComputed.length
              "
              @click="nextItem(attoIdListComputed.indexOf(selectAttoIdComputed) + 1)"
            />
          </div>
        </div>
        <q-btn v-close-popup icon="close" flat round dense @click="dialogClose" />
      </q-card-section>
      <q-card-section class="result-info-area">
        <div ref="dialogTopElement" class="item-area">
          <div class="img-container emphable-img">
            <AtomImage :exatoms="detailStructure.structure" />
          </div>
          <div class="detail-area">
            <div class="app-low-top">
              <div class="item-title">
                <p>{{ detailStructure.attoId }}</p>
              </div>
              <div class="app-low">
                <p class="detail-label">
                  適用法令：
                  <q-tooltip class="bg-black shadow-4" anchor="bottom end" self="top middle"
                    >毒物、劇物：毒物及び劇物取締法<br />PRTR法　第一種指定化学物質：化学物質排出把握管理促進法
                    第二条第２項<br />PRTR法　第二種指定化学物質：化学物質排出把握管理促進法
                    第二条第３項<br />名称等を表示すべき危険物及び有害物：労働安全衛生法
                    第五十七条、第五十七条の二</q-tooltip
                  >
                </p>
                <ApplyLowLabel
                  :classification-code="detailStructure.reg_group_code"
                  :reg-name="detailStructure.reg_group_name"
                  :prtr-name="detailStructure.prtr_name"
                  :ishl-name="detailStructure.ishl_name"
                />
              </div>
            </div>
            <table class="low-area-list">
              <tr>
                <td class="detail-label first">
                  <p>LogP</p>
                </td>
                <td class="detail-info">
                  <p>{{ detailStructure.logp }}</p>
                </td>
                <td class="space"></td>
                <td class="detail-label">
                  <p>Hbond A</p>
                </td>
                <td class="detail-info">
                  <p>{{ detailStructure.hbondA }}</p>
                </td>
                <td class="space"></td>
                <td class="detail-label">
                  <p>Hbond D</p>
                </td>
                <td class="detail-info">
                  <p>{{ detailStructure.hbondD }}</p>
                </td>
                <td></td>
              </tr>
              <tr>
                <td class="detail-label first">
                  <p>Rot bond</p>
                </td>
                <td class="detail-info">
                  <p>{{ detailStructure.rotBond }}</p>
                </td>
                <td class="space"></td>
                <td class="detail-label">
                  <p>PSA</p>
                </td>
                <td class="detail-info">
                  <p>{{ detailStructure.psa }}</p>
                </td>
                <td class="space"></td>

                <td class="detail-label">
                  <p>HeavyAtom</p>
                </td>
                <td class="detail-info">
                  <p>{{ detailStructure.heavyAtom }}</p>
                </td>
                <td></td>
              </tr>
            </table>
          </div>
          <div class="similar-product-btnarea">
            <q-btn
              v-if="simularProductDisplayStatus === 0 && detailStructure.attoId !== ''"
              color="primary"
              outline
              class="similar-product-btn"
              label="この商品に関する類似品を表示する"
              @click="simProDisp"
            />
          </div>
        </div>
        <div class="supplier-area q-mt-md">
          <div
            :class="
              'labelbtn-table-area chem-table-area ' +
              (supplierRows.length === 0 ? 'table-nodata' : '')
            "
          >
            <q-table
              class="my-sticky-header-column-detail-table"
              :rows="supplierRows"
              :columns="supplierColumns"
              flat
              dense
              separator="cell"
              :hide-no-data="hideNoDataFlg"
              no-data-label="データがありません。"
              no-results-label="検索条件に該当する商品はありませんでした。検索結果にご不明な点がございましたら、お問い合わせください。"
              :rows-per-page-options="[10, 20, 50, 0]"
              rows-per-page-label="件表示"
              :pagination-label="
                (firstRowIndex: any, endRowIndex: any, totalRowsNumber: any) => {
                  return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
                }
              "
              :filter="supplierFilter"
              :filter-method="customFilter"
              :visible-columns="visibleColumns"
              :sort-method="customSort"
            >
              <template #no-data="{ message }">
                <div class="full-width row q-gutter-sm">
                  <q-icon size="24px" name="mdi-alert-circle-outline" />
                  <span class="q-pt-xs">{{ message }}</span>
                </div>
              </template>
              <template #top>
                <div class="filter-select">
                  <q-select
                    v-model="supplierFilter"
                    :options="supplierList"
                    square
                    outlined
                    new-value-mode="add-unique"
                    label="フィルター（サプライヤ）"
                    dense
                    options-dense
                    class="column-filter"
                  >
                    <template #append>
                      <q-btn
                        outlined
                        icon="mdi-eraser"
                        class="cursor-pointer filter-clear"
                        label="クリア"
                        @click.stop="filterClear"
                      />
                    </template>
                  </q-select>
                  <q-select
                    v-model="visibleColumns"
                    multiple
                    outlined
                    dense
                    options-dense
                    display-value="カラム表示設定"
                    emit-value
                    map-options
                    :options="hideableColumns"
                    option-value="name"
                    color="primary"
                    class="column-disp q-btn"
                  ></q-select>
                </div>
              </template>

              <template #header-cell-orderQuotable>
                <q-th class="table-btn-area"></q-th>
              </template>

              <template #body-cell-orderQuotable="body">
                <q-td
                  :class="
                    'table-btn-area ' +
                    (body.row.is_ordered === '1' ||
                    (orderQuotableFlg === OrderQuotableCode.QUOTABLE &&
                      body.row.orderQuotable === OrderQuotableCode.OTHER)
                      ? 'deleted'
                      : '')
                  "
                >
                  <div class="flex">
                    <OrderButton
                      v-if="body.row.orderQuotable === OrderQuotableCode.ORDER"
                      :is-selected="body.row.is_ordered"
                      :order-quotable-flg="orderQuotableFlg"
                      :disabled="poType === 'PO_RE_ARIBA'"
                      @order="detailOrderBtn(body.row)"
                    />
                    <QuotableButton
                      v-else-if="body.row.orderQuotable === OrderQuotableCode.QUOTABLE"
                      :is-selected="body.row.is_ordered"
                      :order-quotable-flg="orderQuotableFlg"
                      :disabled="poType !== 'PO_NORMAL'"
                      @quotable="detailOrderBtn(body.row)"
                    />
                    <p v-else></p>
                  </div>
                </q-td>
              </template>
              <template #body-cell-url="body">
                <q-td
                  :props="body"
                  :class="
                    body.row.is_ordered === '1' ||
                    (orderQuotableFlg === OrderQuotableCode.QUOTABLE &&
                      body.row.orderQuotable === OrderQuotableCode.OTHER)
                      ? 'deleted'
                      : ''
                  "
                  ><a :href="body.value" target="_blank">{{ body.value }}</a></q-td
                >
              </template>
              <template #body-cell-sellingPrice="price">
                <q-td
                  :props="price"
                  :class="
                    price.row.is_ordered === '1' ||
                    (orderQuotableFlg === OrderQuotableCode.QUOTABLE &&
                      price.row.orderQuotable === OrderQuotableCode.OTHER)
                      ? 'deleted'
                      : ''
                  "
                >
                  <p v-if="price.value === '要問合せ'" class="q-mb-none text-left">要問合せ</p>
                  <p v-else class="q-mb-none">{{ price.value }}</p>
                </q-td>
              </template>
              <template #body-cell="cell">
                <q-td
                  :props="cell"
                  :class="
                    cell.row.is_ordered === '1' ||
                    (orderQuotableFlg === OrderQuotableCode.QUOTABLE &&
                      cell.row.orderQuotable === OrderQuotableCode.OTHER)
                      ? 'deleted'
                      : ''
                  "
                >
                  {{ cell.value }}
                </q-td>
              </template>
            </q-table>
          </div>
          <div v-if="poType === 'PO_NORMAL'" class="table-note">
            ※掲載のない容量をご希望の場合、「問合」ボタンよりお問い合わせください。
          </div>
          <div v-else class="table-note" style="align-items: center; display: flex">
            ※

            <img
              class="order_image"
              src="/image/order.gif"
              alt="order"
              style="height: 30px; width: 80px"
            />
            &nbsp;の表示がない商品はお見積りが必要なため、カートへ追加は使用できません。
          </div>
        </div>
        <div
          v-if="simularProductDisplayStatus !== 0"
          ref="simularElement"
          class="similar-product-area q-mt-lg"
        >
          <h4>この商品に関する類似品</h4>
          <div v-if="simularProductDisplayStatus === 1" class="similar-product-container">
            <div v-for="(simData, itd) in simDataList" :key="itd" class="result-wrapper">
              <SimilarCard :result="simData" @on-similer-detail="resultSimdataDetail" />
            </div>
          </div>
          <p v-else class="similar-message">この商品に関する類似品はありません。</p>
        </div>
      </q-card-section>
    </q-card>
    <!-- ダイアログ -->
    <AlertDialog
      :display="dialogDispFlg"
      :level="dialogLevel"
      confirmation
      :title="dialogTitle"
      :text="dialogText"
      @complete="closeDialog()"
    />
  </q-dialog>
</template>
<script setup lang="ts">
import { Loading } from 'quasar';
import { ref, computed, inject } from 'vue';
import { useRouter } from 'vue-router';
import http from '../../common/axios-common';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import OrderQuotableCode from '../../common/code/OrderQuotableCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import countOrderQuotableKey from '../../common/order-quotable-key';
import commaFormat from '../../common/utils/numberUtils';
import OrderButton from '../button/OrderButton.vue';
import QuotableButton from '../button/QuotableButton.vue';
import SimilarCard from '../card/SimilarCard.vue';
import AtomImage from '../images/AtomImage.vue';
import ApplyLowLabel from '../label/ApplyLowLabel.vue';
import AlertDialog from './AlertDialog.vue';
import loginUserStore from '../../store/loginUserStore';

const router = useRouter();

// サプライヤInterface
interface Supplier {
  label: string;
  value: string;
}

interface Props {
  // ATTOIDリスト
  resultAttoIdList: Array<string>;
  // 選択されたATTOID
  selectAttoId: string;
  // 詳細結果ダイアログ表示フラグ
  detailResultFlg: boolean;
  // 試薬フラグ
  reagentFlg: boolean;
  // カテゴリー
  categories: number[];
  // サプライヤ
  suppliers: Supplier[];
}
const props = defineProps<Props>();
const emit = defineEmits(['closeDetailDialog', 'detailResultDialogFlg']);

// 注文問い合わせ件数取得
const countOrderQuotable = inject(countOrderQuotableKey);

// 初期表示読み込み時「データがありません」を非表示にするためのフラグ(falseで表示)
const hideNoDataFlg = ref(true);

// ダイアログ表示フラグ
const detailResultFlgComputed = computed(() => props.detailResultFlg);

// パンチアウト種別
const roleType = ref('');
const poType = ref('');

// ログイン情報取得
const getLoginUser = () => {
  const loginUser = loginUserStore();
  http
    .post('/ctp001001/loginUser')
    .then((response) => {
      // 異常終了の場合
      if (response.data.common.status === ResultStatusCode.ERROR) {
        router.push({ name: 'error' });
      } else {
        // ログインユーザー情報をstoreに設定
        loginUser.setLoginUser(response.data.loginUser);
        // ユーザーID設定
        roleType.value = loginUser.role;
        poType.value = loginUser.po_type;
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    });
};

// ATTO ID一覧
const attoIdList = ref<Array<string>>(props.resultAttoIdList);
const attoIdListComputed = computed({
  get: () => attoIdList.value || props.resultAttoIdList,
  set: (value) => {
    attoIdList.value = value;
  },
});

// ATTO ID
const attoId = ref<string>(props.selectAttoId);
const selectAttoIdComputed = computed({
  get: () => attoId.value || props.selectAttoId,
  set: (value) => {
    attoId.value = value;
  },
});

// カラム表示機能
interface HideableColumn {
  name: string;
  label: string;
}

// 構造式詳細
interface DetailStructure {
  attoId: string;
  reg_group_code: string;
  reg_group_name: string;
  prtr_name: string;
  ishl_name: string;
  structure: string;
  structure_txt: string;
  logp: string;
  hbondD: string;
  hbondA: string;
  rotBond: string;
  psa: string;
  heavyAtom: string;
}

// 検索結果
interface SimilarResult {
  atto_id: string;
  atto_supplier_count: number;
  order_count: number;
  condition_id: number;
  result_id: number;
  result_number: number;
  structure: string;
}

const detailStructure = ref<DetailStructure>({
  attoId: '',
  reg_group_code: '',
  reg_group_name: '',
  prtr_name: '',
  ishl_name: '',
  structure: '',
  structure_txt: '',
  logp: '',
  hbondD: '',
  hbondA: '',
  rotBond: '',
  psa: '',
  heavyAtom: '',
});

const supplierList = ref<Array<string>>([]);

// サプライヤフィルター
const supplierFilter = ref<string>('');

// 取扱サプライヤのテーブルカラム(試薬用・大量用でカラムが切り替わる)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const supplierColumns = ref<Array<any>>([]);
// 取扱サプライヤのテーブル一覧
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const supplierRows = ref<Array<any>>([]);

// 注文問い合わせフラグ
const orderQuotableFlg = ref<string>('2');

// ダイアログ内のデータが検索結果の類似品かどうか
const showSimilarDataFlg = ref(false);

// 試薬カラム（テーブルカラム）
const REAGENT_COLUMS = [
  {
    name: 'resultDetailAttoId',
    label: '',
    field: 'resultDetailAttoId',
    display: false,
  },
  {
    name: 'orderQuotable',
    label: '',
    field: 'orderQuotable',
    required: true,
    sortable: true,
  },
  {
    name: 'supplier_name',
    required: true,
    label: 'サプライヤ',
    align: 'left',
    sortable: true,
    field: 'supplier_name',
  },
  {
    name: 'id_number',
    label: 'サプライヤ商品コード',
    align: 'left',
    sortable: true,
    field: 'id_number',
  },
  {
    name: 'cas',
    label: 'CAS No.',
    align: 'left',
    sortable: true,
    field: 'cas',
  },
  {
    name: 'name',
    label: '化学名',
    align: 'left',
    sortable: true,
    field: 'name',
  },
  {
    name: 'capacity',
    label: '容量',
    align: 'left',
    sortable: true,
    sort: (a: string, b: string) =>
      Number(a.split(/[^0-9]/g).join('')) - Number(b.split(/[^0-9]/g).join('')),
    field: 'capacity',
  },
  {
    name: 'use',
    label: '用途',
    align: 'left',
    sortable: true,
    field: 'use',
  },
  {
    name: 'total_amount',
    label: '在庫量（現地）',
    align: 'left',
    sortable: true,
    field: 'total_amount',
  },
  {
    // 納入価格項目値
    name: 'sellingPrice',
    label: '納入価格（税抜）',
    align: 'left',
    sortable: true,
    sort: (a: string, b: string) =>
      Number(a.split(/[^0-9]/g).join('')) - Number(b.split(/[^0-9]/g).join('')),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    field: (row: any) =>
      row.sellingPrice ? `¥${commaFormat(Number(row.sellingPrice))}` : '要問合せ',
    classes: 'text-right',
  },
  {
    name: 'deliveryTime',
    label: '納期',
    align: 'left',
    sortable: true,
    field: 'deliveryTime',
  },
  {
    name: 'purity',
    label: '純度',
    align: 'left',
    sortable: true,
    field: 'purity',
    classes: 'text-right',
  },
  {
    name: 'mdl',
    label: 'MDL',
    align: 'left',
    sortable: true,
    field: 'mdl',
  },
];

// 大量品カラム（テーブルカラム）
const BULK_COLUMS = [
  {
    name: 'resultDetailAttoId',
    label: '',
    field: 'resultDetailAttoId',
    display: false,
  },
  {
    name: 'orderQuotable',
    label: '',
    field: 'orderQuotable',
    required: true,
    sortable: true,
  },
  {
    name: 'supplier_name',
    required: true,
    label: 'サプライヤ',
    align: 'left',
    sortable: true,
    field: 'supplier_name',
  },
  {
    name: 'id_number',
    label: 'サプライヤ商品コード',
    align: 'left',
    sortable: true,
    field: 'id_number',
  },
  {
    name: 'cas',
    label: 'CAS No.',
    align: 'left',
    sortable: true,
    field: 'cas',
  },
  {
    name: 'name',
    label: '化学名',
    align: 'left',
    sortable: true,
    field: 'name',
  },
  {
    name: 'capacity',
    label: '容量',
    align: 'left',
    sortable: true,
    field: 'capacity',
  },
  {
    name: 'use',
    label: '用途',
    align: 'left',
    sortable: true,
    field: 'use',
  },
  {
    name: 'packing',
    label: '荷姿',
    align: 'left',
    sortable: true,
    field: 'packing',
  },
];

// 試薬表示カラム
const REAGENT_VISIBLE_COLUMS = [
  'orderQuotable',
  'supplier_code',
  'id_number',
  'cas',
  'name',
  'capacity',
  'use',
  'total_amount',
  'sellingPrice',
  'deliveryTime',
  'purity',
  'mdl',
];

// 大量品表示カラム
const BULK_VISIBLE_COLUMS = [
  'orderQuotable',
  'supplier_code',
  'id_number',
  'cas',
  'name',
  'capacity',
  'use',
  'packing',
];

// 試薬非表示可能カラム
const REAGENT_HIDEABLE_COLUMS = [
  {
    name: 'id_number',
    label: 'サプライヤ商品コード',
  },
  {
    name: 'cas',
    label: 'CAS No.',
  },
  {
    name: 'name',
    label: '化学名',
  },
  {
    name: 'capacity',
    label: '容量',
  },
  {
    name: 'use',
    label: '用途',
  },
  {
    name: 'total_amount',
    label: '在庫量（現地）',
  },
  {
    name: 'sellingPrice',
    label: '納入価格（税抜）',
  },
  {
    name: 'deliveryTime',
    label: '納期',
  },
  {
    name: 'purity',
    label: '純度',
  },
  {
    name: 'mdl',
    label: 'MDL',
  },
];

// 大量品非表示可能カラム
const BULK_HIDEABLE_COLUMS = [
  {
    name: 'id_number',
    label: 'サプライヤ商品コード',
  },
  {
    name: 'cas',
    label: 'CAS No.',
  },
  {
    name: 'name',
    label: '化学名',
  },
  {
    name: 'capacity',
    label: '容量',
  },
  {
    name: 'use',
    label: '用途',
  },
  {
    name: 'packing',
    label: '荷姿',
  },
];

// カラム表示設定
const visibleColumns = ref<Array<string>>([]);
// カラム非表示設定
const hideableColumns = ref<Array<HideableColumn>>([]);

// 類似品の商品情報
const simDataList = ref<Array<SimilarResult>>([]);

// 類似品のATTOID一覧
const simAttoIdList = ref<Array<string>>([]);

// 類似品一覧表示ステータス（0:非表示、1:表示、2:類似品なし）
const simularProductDisplayStatus = ref(0);
// ページャー表示フラグ
const showResultPagerFlg = ref(true);
// ダイアログtop要素
const dialogTopElement = ref<HTMLImageElement>();
// 類似品要素
const simularElement = ref<HTMLImageElement>();

// ダイアログ表示
const dialogDispFlg = ref<boolean>(false);
// Dialog表示レベル
const dialogLevel = ref('');
// ダイアログテキスト
const dialogText = ref<Array<string>>(['']);
// ダイアログタイトル
const dialogTitle = ref<string>('');

// ダイアログを閉じる
const closeDialog = () => {
  dialogDispFlg.value = false;
  emit('detailResultDialogFlg', false);
};

// テーブル初期設定
const initTable = () => {
  getLoginUser();
  // 選択された品目のユニークなサプライヤ情報をもとに取扱サプライヤのデータをセット
  if (props.reagentFlg) {
    supplierColumns.value = REAGENT_COLUMS;
    visibleColumns.value = REAGENT_VISIBLE_COLUMS;
    hideableColumns.value = REAGENT_HIDEABLE_COLUMS;
  } else {
    supplierColumns.value = BULK_COLUMS;
    visibleColumns.value = BULK_VISIBLE_COLUMS;
    hideableColumns.value = BULK_HIDEABLE_COLUMS;
  }

  supplierRows.value = [];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const customSort = (rows: readonly any[], sortBy: string, descending: boolean) => {
  const data = [...rows];

  if (sortBy) {
    data.sort((a, b) => {
      let x = a;
      let y = b;

      let status = 0;
      if (x.orderQuotable !== y.orderQuotable) {
        status = -1;
        if (x.orderQuotable > y.orderQuotable) {
          status = 1;
        }
        return status;
      }
      x = descending ? b : a;
      y = descending ? a : b;

      status = 0;
      if (x[sortBy] === null && y[sortBy] === null) {
        status = 0;
      } else if (x[sortBy] === null || x[sortBy] === '要問合せ') {
        status = descending ? -1 : 1;
      } else if (y[sortBy] === null || y[sortBy] === '要問合せ') {
        status = descending ? 1 : -1;
      } else if (sortBy === 'capacity' || sortBy === 'sellingPrice') {
        status =
          Number(x[sortBy].split(/[^0-9.]/g).join('')) -
          Number(y[sortBy].split(/[^0-9.]/g).join(''));
      } else if (x[sortBy] > y[sortBy]) {
        status = 1;
      } else if (x[sortBy] < y[sortBy]) {
        status = -1;
      } else {
        status = 0;
      }

      return status;
    });
  }
  return data;
};

// 詳細結果検索
const detailSearch = () => {
  // Loading Start
  Loading.show();

  const formData = new FormData();
  formData.append('attoId', attoId.value);
  props.categories.forEach((category) => formData.append('sup_category_ids', category.toString()));
  props.suppliers.forEach((supplier: { label: string; value: string }) => {
    formData.append('supplier_ids', supplier.value);
  });

  http
    .post('/csr002004/detailReslut', formData)
    .then((response) => {
      if (response.data.common.status === ResultStatusCode.ERROR) {
        if (response.data.common.detail_status === DetailResultStatusCode.MAX_MOL_ERROR) {
          // 商品上限値超過エラー
          dialogLevel.value = 'error';
          dialogTitle.value = '商品数上限件数エラー';
          dialogText.value = [
            '１回の注文・問い合わせで追加可能な商品数は３００商品までとなっております。',
          ];
          dialogDispFlg.value = true;
        } else if (
          response.data.common.detail_status === DetailResultStatusCode.CHECK_ATTOID_ERROR
        ) {
          // ATTO_ID取得エラー
          dialogLevel.value = 'error';
          dialogTitle.value = '化合物に変更がありました';
          dialogText.value = [
            '当化合物は取り扱い不可の分類に変更されたため、詳細結果画面に表示できません。',
            '詳細結果画面を閉じて、検索画面から再検索してください。',
          ];
          dialogDispFlg.value = true;
        } else if (
          response.data.common.detail_status === DetailResultStatusCode.PRODUCTS_NOT_AVAILABLE_ERROR
        ) {
          // 取り扱い不可商品エラー
          dialogLevel.value = 'error';
          dialogText.value = [
            '該当化合物は取り扱い不可の分類に変更されたため、詳細結果画面に表示できません。',
            '詳細結果画面を閉じて、検索画面から再検索してください。',
          ];
          dialogTitle.value = '取り扱い商品に変更がありました';
          dialogDispFlg.value = true;
          // 初期値設定
          detailStructure.value = {
            attoId: '',
            reg_group_code: '',
            reg_group_name: '',
            prtr_name: '',
            ishl_name: '',
            structure: '',
            structure_txt: '',
            logp: '',
            hbondD: '',
            hbondA: '',
            rotBond: '',
            psa: '',
            heavyAtom: '',
          };
          supplierRows.value = [];
          supplierList.value = [];
        } else {
          router.push({ name: 'error' });
        }
      } else {
        detailStructure.value = response.data.detailStructure;
        supplierRows.value = response.data.searchResultInfo;
        supplierList.value = response.data.supplierNameList;
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // 注文/問合選択状態を一旦フラットにする
      orderQuotableFlg.value = OrderQuotableCode.OTHER;

      // 商品の状態を確認しボタンの選択状態を決める
      for (let i = 0; i < supplierRows.value.length; i += 1) {
        if (supplierRows.value[i].is_ordered === '1') {
          // 注文済み && 注文可能商品の場合に問合せボタンを非活性にしてbreak
          if (supplierRows.value[i].orderQuotable === OrderQuotableCode.ORDER) {
            orderQuotableFlg.value = OrderQuotableCode.ORDER;
            break;
          }
          // 問合せ済み && 問合せ可能商品の場合に全ての注文ボタンを非活性にしてbreak
          if (supplierRows.value[i].orderQuotable === OrderQuotableCode.QUOTABLE) {
            orderQuotableFlg.value = OrderQuotableCode.QUOTABLE;
            break;
          }
        }
      }
      // 注文商品の場合
      if (orderQuotableFlg.value === OrderQuotableCode.ORDER) {
        for (let i = 0; i < supplierRows.value.length; i += 1) {
          // 注文商品が1つでも存在する場合は、問合せボタンを非選択状態にする
          if (supplierRows.value[i].orderQuotable === OrderQuotableCode.QUOTABLE) {
            supplierRows.value[i].is_ordered = '0';
          }
        }
      }
      // Loading End
      Loading.hide();
      hideNoDataFlg.value = false;
    });
};

// 類似品取得
const getSimilar = () => {
  // Loading Start
  Loading.show();

  const formData = new FormData();
  formData.append('type', 'STRUCTURE');
  formData.append('extension', 'STRUCTURE');
  formData.append('structure', detailStructure.value.structure_txt);
  formData.append('searchType', 'similar');
  formData.append('attoId', attoId.value);
  formData.append('threshold', '0.7');
  props.categories.forEach((category) => formData.append('sup_category_ids', category.toString()));
  props.suppliers.forEach((supplier: { label: string; value: string }) => {
    formData.append('supplier_ids', supplier.value);
  });

  http
    .post('/csr002002/structureSerach', formData)
    .then((response) => {
      if (response.data.common.status === ResultStatusCode.ERROR) {
        router.push({ name: 'error' });
      } else {
        simAttoIdList.value = response.data.searchResultInfo.attoIdList;
        simDataList.value = response.data.searchResultInfo[0].searchResultDetailList;
        // 類似品一覧表示
        if (simDataList.value !== null) {
          simularProductDisplayStatus.value = 1;
        } else {
          simularProductDisplayStatus.value = 2;
        }
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * 注文問合
 * @param resultDetailAttoId 詳細結果で選択したATTO_ID
 * @param orderedFlg ボタン選択状態(0:未選択 1:選択済)
 * @param orderQuotableFlag 画面表示モード
 */
const orderQuotable = (
  resultDetailAttoId: string,
  orderedFlg: string,
  orderQuotableFlag: string
) => {
  // Loading Start
  Loading.show();

  const formData = new FormData();
  formData.append('result_detail_atto_id', resultDetailAttoId);
  formData.append('orderQuotable', orderQuotableFlag);
  formData.append('is_ordered', orderedFlg);
  formData.append('attoId', attoId.value);

  http
    .post('/csr002004/orderQuotable', formData)
    .then((response) => {
      if (response.data.common.status === ResultStatusCode.ERROR) {
        if (response.data.common.detail_status === DetailResultStatusCode.MAX_MOL_ERROR) {
          // 商品上限値超過エラー
          dialogLevel.value = 'error';
          dialogTitle.value = '商品数上限件数エラー';
          dialogText.value = [
            '１回の注文・問い合わせで追加可能な商品数は３００商品までとなっております。',
          ];
          dialogDispFlg.value = true;
        } else if (response.data.common.detail_status === DetailResultStatusCode.CHECK_MOL_ERROR) {
          // 商品チェックエラー
          dialogLevel.value = 'error';
          dialogTitle.value = '商品追加エラー';
          dialogText.value = ['すでに注文・問合せされている商品のため選択できません。'];
          dialogDispFlg.value = true;
        } else {
          // エラー画面遷移
          router.push({ name: 'error' });
        }
      }
      // 注文問い合わせ件数再取得
      countOrderQuotable?.();
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // 問合が取り消されたとき
      if (orderedFlg === '0' && orderQuotableFlag === OrderQuotableCode.QUOTABLE) {
        // ボタンを全て活性化に戻す
        orderQuotableFlg.value = OrderQuotableCode.OTHER;
      }
      // 注文が取り消されたとき
      if (orderedFlg === '0' && orderQuotableFlag === OrderQuotableCode.ORDER) {
        let count = 0;
        // 選択済みの注文商品の存在を確認
        for (let i = 0; i < supplierRows.value.length; i += 1) {
          // ボタンが選択済みかつ注文の場合
          if (
            supplierRows.value[i].is_ordered === '1' &&
            supplierRows.value[i].orderQuotable === OrderQuotableCode.ORDER
          ) {
            count += 1;
          }
        }
        // 注文商品が0件の場合、ボタンを全て活性化に戻す
        if (count === 0) {
          orderQuotableFlg.value = OrderQuotableCode.OTHER;
        }
      }
      // Loading End
      Loading.hide();
    });
};

// ダイアログ内のサプライヤテーブルのフィルターの選択を解除する
const filterClear = () => {
  supplierFilter.value = '';
};

// 取扱テーブルのフィルタリング
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const customFilter = (rows: any, terms: any) => {
  const lowerSearch = terms || '';

  // rowsの中身分ループ処理してフィルタリングを実行
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const filteredRows = rows.filter((row: any) => {
    let ans = false;
    let s1 = true;

    if (lowerSearch !== '') {
      s1 = false;
      // サプライヤ名に入力された文字列が一致するかどうかの判定
      if (row.supplier_name && row.supplier_name.includes(lowerSearch)) {
        s1 = true;
      }
    }

    if (s1) {
      ans = true;
    }
    return ans;
  });
  return filteredRows;
};

// ダイアログ内の類似品詳細表示ボタン押下時
const resultSimdataDetail = (selectAttoId: string) => {
  simularProductDisplayStatus.value = 0;
  attoId.value = selectAttoId;
  attoIdList.value = simAttoIdList.value;
  // 詳細検索
  detailSearch();
  // ページャーを非表示
  showResultPagerFlg.value = false;
  // フィルターのクリア
  filterClear();
  // スクロール
  dialogTopElement.value?.scrollIntoView(true);
};

// テーブル内の注文ボタン押下時
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const detailOrderBtn = (row: any) => {
  if (row.is_ordered === '0') {
    supplierRows.value[supplierRows.value.findIndex((object) => object === row)].is_ordered = '1';
    orderQuotableFlg.value =
      supplierRows.value[supplierRows.value.findIndex((object) => object === row)].orderQuotable;
    // 注文問合取消
    orderQuotable(row.resultDetailAttoId, '1', orderQuotableFlg.value);
  } else {
    supplierRows.value[supplierRows.value.findIndex((object) => object === row)].is_ordered = '0';
    orderQuotableFlg.value =
      supplierRows.value[supplierRows.value.findIndex((object) => object === row)].orderQuotable;
    // 注文問合取消
    orderQuotable(row.resultDetailAttoId, '0', orderQuotableFlg.value);
  }
};

// 類似ボタン押下時
const simProDisp = () => {
  simDataList.value = [];
  // 類似品検索
  getSimilar();
  showSimilarDataFlg.value = true;
  // スクロール
  setTimeout(() => simularElement.value?.scrollIntoView(true), 800);
};

// 品目詳細ダイアログを閉じる
const dialogClose = () => {
  // フィルターを使用していた場合はフィルターをクリア
  filterClear();
  showSimilarDataFlg.value = false;
  // ページャーを非表示
  showResultPagerFlg.value = true;
  // 類似品目の表示を非表示にする
  simularProductDisplayStatus.value = 0;
  emit('closeDetailDialog');
};

// 品目詳細の前の品目に移動ボタン押下時
const previousItem = (itemNumber: number) => {
  selectAttoIdComputed.value = attoIdListComputed.value[itemNumber];
  // 詳細検索
  detailSearch();
  // フィルターを使用していた場合はフィルターをクリア
  filterClear();
  // 類似品一覧非表示
  simularProductDisplayStatus.value = 0;
};

// 品目詳細の次の品目に移動ボタン押下時
const nextItem = (itemNumber: number) => {
  selectAttoIdComputed.value = attoIdListComputed.value[itemNumber];
  // 詳細検索
  detailSearch();
  // フィルターを使用していた場合はフィルターをクリア
  filterClear();
  // 類似品一覧非表示
  simularProductDisplayStatus.value = 0;
};

// 初期表示
initTable();
detailSearch();
</script>
<style scoped>
p,
label,
span,
h3,
h4 {
  margin: 0;
  padding: 0;
}

h4 {
  padding-left: 18px;
  position: relative;
}

h4:before {
  content: '';
  width: 4px;
  height: 28px;
  position: absolute;
  left: 2px;
  top: 6px;
  background-color: var(--q-primary);
}

.itemdetail-dialog .similar-product-container .result-wrapper {
  width: 24%;
  margin-left: 1%;
  border: 2px solid var(--q-lightColorBorder);
  margin-top: 10px;
  max-width: 270px;
  margin-bottom: 10px;
  padding-bottom: 12px;
  border-radius: 3px;
}

.itemdetail-dialog .similar-message {
  margin-left: 1rem;
  margin-bottom: 40px;
  margin-top: 25px;
  letter-spacing: 1px;
  font-weight: bold;
  font-size: 1.1rem;
}

/* 品目詳細 */
.itemdetail-dialog .q-card {
  max-width: unset;
  width: 100%;
  min-width: 1200px;
  height: 100%;
  overflow: unset !important;
  overflow-y: unset !important;
}

.itemdetail-dialog .dialog-header-left {
  width: 960px;
  display: flex;
  align-items: center;
}

.itemdetail-dialog h3 {
  color: var(--q-primary);
  font-size: 1.6rem;
  line-height: 1.6rem;
  letter-spacing: 6px;
}

.itemdetail-dialog .result-dialog-header {
  height: 50px;
  margin-bottom: 15px;
  justify-content: space-between;
}

.itemdetail-dialog .result-info-area {
  padding-top: 0;
  position: relative;
  max-height: calc(100% - 65px);
  overflow-y: scroll;
}

.itemdetail-dialog .pagination {
  width: calc(100% - 32px);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: absolute;
}

.itemdetail-dialog .pagination-content {
  width: 1000px;
  margin: 0 auto;
  justify-content: center;
}

.itemdetail-dialog .pagination p {
  margin: 0 60px;
  letter-spacing: 2px;
  font-size: 1.1rem;
}

.itemdetail-dialog .pagination p span {
  font-size: 1.3rem;
  margin-right: 5px;
}

.itemdetail-dialog .pagination .pager-icon {
  color: var(--q-plainBlack);
  cursor: pointer;
  border-radius: 4px;
  padding: 0 2px;
  height: 40px;
  border: 1px solid var(--q-whiteBorder);
}

.itemdetail-dialog .pagination .pager-icon.disabled {
  cursor: default !important;
  opacity: 0.4 !important;
}

.itemdetail-dialog .detail-top-wrapper {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.itemdetail-dialog .item-area {
  /* border: 1px solid var(--q-plainBlack); */
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  display: flex;
  padding: 12px 20px;
  background-color: var(--q-lightGray);
  position: relative;
  width: 1000px;
  margin: 0 auto;
}

.itemdetail-dialog .img-container {
  width: 180px;
  margin-right: 20px;
  display: flex;
  align-items: center;
}

.itemdetail-dialog .detail-area {
  width: calc(100% - 200px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.itemdetail-dialog .detail-area .item-title {
  width: 100%;
}
.itemdetail-dialog .detail-area .item-title p {
  letter-spacing: 2px;
  font-size: 18px;
  min-height: 33px;
  padding: 3px 0 1px;
  padding-left: 2px;
  width: 200px;
  margin-bottom: 10px;
  text-align: center;
  border: 1px solid var(--q-plainBlack);
}

.itemdetail-dialog .detail-area .app-low {
  width: 100%;
  justify-content: flex-start;
  margin-bottom: 10px;
  align-items: center;
  margin-top: 25px;
}

.itemdetail-dialog .app-low {
  display: flex;
  justify-content: space-between;
  margin-right: 25px;
  font-size: 1.1rem;
  line-height: 1.1rem;
}

.itemdetail-dialog .detail-area .detail-label {
  margin-right: 10px;
  font-size: 0.9rem;
  line-height: 0.9rem;
  letter-spacing: 2px;
  cursor: pointer;
  letter-spacing: 2px;
  width: 86px;
  margin-top: 2px;
  opacity: 0.8;
}

.itemdetail-dialog .detail-area .low-area-list {
  max-width: 680px;
}

.itemdetail-dialog .detail-area .low-area-list tr {
  width: 100%;
}

.itemdetail-dialog .detail-area .low-area-list td {
  height: 30px;
}

.itemdetail-dialog .detail-area .low-area-list td.detail-label {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
}

.itemdetail-dialog .detail-area .low-area-list td.detail-label p {
  /* font-size: 16px; */
  font-weight: normal;
  font-size: 0.9rem;
  letter-spacing: 2px;
}

.itemdetail-dialog .detail-area .low-area-list td.detail-info {
  width: 90px;
  min-width: 90px;
  max-width: 90px;
}

.itemdetail-dialog .detail-area .low-area-list td.detail-info p {
  font-size: 18px;
  text-align: right;
}

.itemdetail-dialog .detail-area .low-area-list td.space {
  width: 40px;
}

.itemdetail-dialog .supplier-area {
  margin-top: 28px;
}
.itemdetail-dialog h4 {
  font-size: 1.3rem;
  line-height: 1.3rem;
  margin-bottom: 10px;
  padding-top: 10px;
}

.labelbtn-table-area .q-table__container {
  margin: 60px auto 0;
}

.itemdetail-dialog .similar-product-btnarea {
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: var(--q-pureWhite);
}

.itemdetail-dialog .similar-product-btn {
  padding: 8px 16px;
  font-size: 12px;
  letter-spacing: 1px;
}

.chem-table-area.labelbtn-table-area .q-table__top.relative-position .column-filter {
  width: 260px;
  margin-right: 110px;
}

.labelbtn-table-area .q-table tr th {
  height: 32px;
}

.labelbtn-table-area td.table-btn-area {
  display: flex;
  justify-content: center;
}

.labelbtn-table-area .q-table .table-btn-area {
  width: 100px;
}

.labelbtn-table-area .table-btn-area button {
  width: 86px;
  padding: 4px 6px;
  min-height: unset;
}

.labelbtn-table-area .table-btn-area button.orderable {
  background-color: var(--q-primary);
  border: 2px solid transparent;
  color: white;
}

.labelbtn-table-area .table-btn-area button.needInquiry {
  background-color: var(--q-inquiry);
  border: 2px solid transparent;
  color: white;
}

.labelbtn-table-area .table-btn-area button.inactive {
  background-color: white;
}

.labelbtn-table-area .table-btn-area button.inactive.orderable {
  color: var(--q-primary);
  border-color: var(--q-primary);
}

button.label_orderable {
  background-color: var(--q-primary);
  border: 2px solid transparent;
  color: white;
  width: 92px;
  height: 26px;
  cursor: initial;
}
.labelbtn-table-area .table-btn-area button.inactive.needInquiry {
  color: var(--q-inquiry);
  border-color: var(--q-inquiry);
}

.labelbtn-table-area .table-btn-area button.disabled {
  opacity: 0.6 !important;
  background-color: #5e5e5e;
  color: white;
  cursor: default !important;
}

.labelbtn-table-area .table-btn-area button.disabled * {
  cursor: default !important;
}

/* カラム表示切替フィルター、カラムデータフィルター */
.filter-select {
  width: 100%;
  position: relative;
  display: flex;
}

.filter-select .column-filter .q-btn.q-btn-item {
  position: absolute;
  right: -95px;
  width: 90px;
  padding: 0px 6px 0px 4px;
  height: 36px;
}

/* 類似品を表示 */
.similar-product-area .similar-product-container {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px;
}

.itemdetail-dialog .similar-product-area .result-wrapper {
  width: 208px;
  margin: 0 4px 10px 0;
}

@media screen and (min-width: 1500px) {
  .itemdetail-dialog .result-dialog-header {
    justify-content: space-between;
  }
  .itemdetail-dialog .pagination {
    width: 100%;
    position: absolute;
    top: 16px;
    left: 0;
  }
}
</style>
<style>
.filter-select .column-disp .q-field__append.q-field__marginal.row.q-anchor--skip {
  display: none;
}

.filter-select .column-disp .q-field__native {
  justify-content: center;
}

.filter-select .column-disp span {
  color: var(--q-primary);
}

.filter-select .column-disp.q-field--outlined .q-field__control:before,
.filter-select .column-disp.q-field--outlined .q-field__control:hover:before {
  border: none;
}

.filter-select label.column-disp.q-field .q-field__control {
  border: 1px solid var(--q-primary) !important;
  outline: none !important;
}

.filter-select .column-filter.q-field--dense.q-field--float .q-field__label {
  transform: unset;
  opacity: 0;
}

.filter-select
  .column-filter.q-field--auto-height.q-field--dense.q-field--labeled
  .q-field__control-container {
  padding: 0;
}

.similar-product-btn.q-btn--outline:before {
  box-shadow: 0 1px 5px rgb(0 0 0 / 20%), 0 2px 2px rgb(0 0 0 / 14%),
    0 3px 1px -2px rgb(0 0 0 / 12%);
}

.itemdetail-dialog .pagination .pager-icon.disabled * {
  cursor: default !important;
  background: none !important;
}

.itemdetail-dialog .supplier-area .table-note {
  font-size: 0.8rem;
  line-height: 0.8rem;
  letter-spacing: 1px;
  margin-top: 12px;
}

.itemdetail-dialog .pagination .pager-icon.q-btn--actionable.q-btn--standard:before {
  box-shadow: none;
}

/* 品目詳細用テーブル */
.labelbtn-table-area.chem-table-area .q-table__top.relative-position.row {
  border: none;
}

.labelbtn-table-area .table-btn-area button .q-btn__content {
  justify-content: center;
}

.labelbtn-table-area .q-table .table-btn-area .q-icon {
  font-size: 18px;
  margin-right: 6px;
}

.labelbtn-table-area .q-table .table-btn-area .block {
  font-size: 14px;
  line-height: 14px;
}

.labelbtn-table-area .q-table__control {
  margin-left: 20px;
}

.labelbtn-table-area .q-table__control span {
  letter-spacing: 1px;
}

.labelbtn-table-area .filter-clear {
  border: 1px solid var(--q-delete);
}

.labelbtn-table-area .filter-clear .q-icon.mdi-eraser {
  margin-right: 0;
  margin-bottom: 1px;
}

.itemdetail-dialog .q-dialog__inner--minimized {
  padding: 55px 12px;
}

.labelbtn-table-area.table-nodata .q-table__bottom--nodata span {
  padding-top: 12px;
  margin-left: 8px;
}
</style>

<style lang="sass">
.my-sticky-header-column-detail-table
  /* height or max-height is important */
  max-height: 490px

  /* specifying max-width so the example can
    highlight the sticky column on any browser window */

  td:first-child
    /* bg color is important for td; just specify one */
    background-color: #fff

  tr th
    position: sticky
    /* higher than z-index for td below */
    z-index: 2
    /* bg color is important; just specify one */
    background: #fff

  /* this will be the loading indicator */
  thead tr:last-child th
    /* height of all previous header rows */
    top: 48px
    /* highest z-index */
    z-index: 3
  thead tr:first-child th
    top: 0
    z-index: 1
  tr:first-child th:first-child
    /* highest z-index */
    z-index: 3

  td:first-child
    z-index: 1

  td:first-child, th:first-child
    position: sticky
    left: 0

  /* prevent scrolling behind sticky top row on focus */
  tbody
    /* height of all previous header rows */
    scroll-margin-top: 48px
</style>
